import { Card, CardBody, CardHeader, Col, Container } from "reactstrap";
import CardHeaderLayout from "../../Component/Templates/Card/CardHeaderLayout";

const FeatureContainer = ({
  title,
  subtitle,
  createButton,
  children,
  type,
  statusList,
}) => {
  return (
    <Container fluid={true}>
      <Col md="12">
        {type === "pengaturan" ? (
          <>
            <Card className="project-list">
              <CardHeaderLayout button={createButton} />
            </Card>
            <Card>
              <CardBody>{children}</CardBody>
            </Card>
          </>
        ) : (
          <Card>
            {(title || statusList) && (
              <CardHeader className="d-flex justify-content-between">
                <div className="col">
                  <h5>{title}</h5>
                  <span>{subtitle || title}</span>
                </div>
              </CardHeader>
            )}
            {createButton && (
              <CardHeader>
                <div className="col project-list">{createButton}</div>
              </CardHeader>
            )}
            <CardBody>{children}</CardBody>
          </Card>
        )}
      </Col>
    </Container>
  );
};

export default FeatureContainer;
